import React from "react";
import CardStats from "components/Cards/CardStats.js";

export default function HeaderStats({ stats }) {
  return (
    <>
      {/* Header */}
      <div className="relative bg-lightBlue-600 md:pt-32 pb-32 pt-12">
        <div className="px-4 md:px-10 mx-auto w-full">
          <div>
            {/* Card stats */}
            <div className="flex flex-wrap">
              {stats.map((stat, index) => (
                <div key={index} className="w-full lg:w-6/12 xl:w-3/12 px-4">
                  <CardStats
                    statSubtitle={stat.statSubtitle}
                    // format number to currency for example if the number is 1000 it will be formatted to 1K and if the number is 1000000 it will be formatted to 1M
                    statTitle={Math.abs(stat.statTitle) > 999
                      ? Math.sign(stat.statTitle)*((Math.abs(stat.statTitle)/1000).toFixed(1)) + 'K'
                      : Math.sign(stat.statTitle)*Math.abs(stat.statTitle)
                    }
                    statArrow={stat.statArrow}
                    statPercent={stat.statPercent}
                    statPercentColor={stat.statPercentColor}
                    statDescripiron={stat.statDescripiron}
                    statIconName={stat.statIconName}
                    statIconColor={stat.statIconColor}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
